import React from "react";
import styled from "styled-components";
import { path } from "ramda";
import UpdateTopNineHandler from "../common/Checkout/UpdateTopNineHandler";
import { withUnlockTopNine } from "../../core/withUnlockTopNine";
import SuccessModal from "../common/SuccessPurchaseModal";
import BuyForm from "../common/Checkout/BuyForm";
import SupportUs from "./SupportUs";
import UnlockTopNineInfo from "./UnlockTopNineInfo";
import PaymentRequired from "./PaymentRequired";

const getTopNineOrderId = path(["topNineOrders", 0, "id"]);
const getToken = path(["token"]);

const UnlockTopNine = props => (
  <Container>
    <React.Fragment>
      <SuccessModal open={props.successModalOpen} onClose={props.onRequestClose} />
      {props.status !== "success" && (
        <BuyTopNine setStatus={props.handleSetStatus} {...props} isLoading={props.status === "loading"} />
      )}
    </React.Fragment>
  </Container>
);

const BuyTopNine = ({
  user,
  setStatus,
  status,
  isLoading,
  onRequestClose,
  paymentRequired,
  refreshCurrentUser,
  unlockTopNinePrice,
}) => (
  <DetailContainer>
    <PaymentRequired user={user} />
    <UpdateTopNineHandler userToken={getToken(user)} id={getTopNineOrderId(user)}>
      {({ updateTopNineOrder, error }) => (
        <React.Fragment>
          <BuyForm
            showStripeCopy={false}
            error={error}
            price={unlockTopNinePrice}
            isLoading={isLoading}
            buttonText={`Get your Top Nine now $(${unlockTopNinePrice ? unlockTopNinePrice / 100 : "1.99"})`}
            onTokenSuccess={token =>
              updateTopNineOrder({
                method: "stripe",
                token: token.id,
              })
                .then(() => {
                  setStatus("success");
                  refreshCurrentUser();
                })
                .catch(() => {
                  setStatus("error");
                })
            }
            paymentOnTokenSuccess={(token, method) =>
              updateTopNineOrder({
                method,
                token: token.id,
              })
                .then(() => {
                  setStatus("success");
                  refreshCurrentUser();
                })
                .catch(() => {
                  setStatus("error");
                })
            }
            onClickButton={() => {
              setStatus("loading");
            }}
          />
          <SupportUs user={user} />
          <UnlockTopNineInfo
            user={user}
            loading={isLoading}
            price={unlockTopNinePrice}
            buttonText={`Get your Top Nine now $(${unlockTopNinePrice ? unlockTopNinePrice / 100 : "1.99"})`}
            updateTopNineOrder={updateTopNineOrder}
            error={error}
            setStatus={setStatus}
            refreshCurrentUser={refreshCurrentUser}
          />
        </React.Fragment>
      )}
    </UpdateTopNineHandler>
  </DetailContainer>
);

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  max-height: 100%;
  align-items: center;
  background: white;
  width: 90vw;
  @media (max-width: 640px) {
    max-width: 420px;
    max-width: 100%;
    width: 100vw;
  }
`;

const DetailContainer = styled.div`
  flex: 1;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-y: auto;
  padding: 16px 24px;
`;

export default withUnlockTopNine(UnlockTopNine);
